<template>
  <tabsLayout class="website-descriptions">
    <div class="mt-3 mb-3">
      <b-button
        class="mr-3 float-right"
        type="button"
        variant="primary"
        v-if="$store.getters.loggedInInfo.is_admin"
        @click="$router.push({ name: 'DescriptionCreate' })"
        >新增</b-button
      >
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="$store.getters.paginationInDescriptionList.last_page"
        @change="$store.dispatch('fetchDescriptions', $event)"
        use-router
      ></b-pagination-nav>
    </div>
    <tableListNoData
      v-if="$store.getters.descriptionList.length === 0"
    ></tableListNoData>
    <tableList
      v-else
      :fields="fields"
      :items="$store.getters.descriptionList"
      :isSelectable="$store.getters.loggedInInfo.is_admin"
      @click="openModal($event)"
      @toDetail="toDetail"
    >
    </tableList>

    <!-- modal -->
    <b-modal ref="double-check-delete-website-descriptions">
      <p class="text-center">是否刪除？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >確定</b-button
          >
        </div>
      </template>
    </b-modal>
  </tabsLayout>
</template>

<script>
import tableList from "@/components/TableList.vue";
import tableListNoData from "@/components/TableListNoData.vue";
import tabsLayout from "@/layout/TabsLayout.vue";
export default {
  name: "WebsiteDescriptions",
  components: {
    tableList,
    tableListNoData,
    tabsLayout
  },
  computed: {
    fields() {
      return [
        { key: "released_at", label: "發布日期", sortable: true },
        { key: "title", label: "標題" },
        { key: "user", label: "撰寫者" }
      ];
    }
  },
  data() {
    return {
      deleteData: {
        description_ids: []
      }
    };
  },
  methods: {
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    openModal(selectedList) {
      this.$refs["double-check-delete-website-descriptions"].show();
      this.setDeleteData(selectedList);
    },
    setDeleteData(selectedList) {
      this.deleteData.description_ids = selectedList.map(item => item.id);
    },
    async submit() {
      await this.$store.dispatch("deleteADescription", this.deleteData);
      this.$refs["double-check-delete-website-descriptions"].hide();
      const page = 1;
      this.$store.dispatch("fetchDescriptions", page);
    },
    toDetail(oneDescription) {
      if (this.$store.getters.loggedInInfo.is_admin) {
        this.$router.push({
          name: "DescriptionEdit",
          params: { id: oneDescription.id }
        });
      } else {
        this.$router.push({
          name: "DescriptionRead",
          params: { id: oneDescription.id }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.website-descriptions {
  padding: 1rem;
  /deep/ .b-table-sticky-header {
    max-height: 60vh;
  }
}
</style>
